import { Col, Container, Row } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { Component } from 'react';
import { resetUserState } from '../../../modules/user';
import { getTeamMembers, setPersonnelLockoutStatus } from '../../../modules/user_api';

import Button from '../../components/button/button';
import TeamMemberCard from '../../components/team-member-card/team-member-card';
import { connect } from 'react-redux';
import { getRoles } from '../../../modules/system/role';
import { parseQuery } from '../../../transformations/queryString';
import { setPageTitle } from '../../../modules/application/pages';
import { toast } from 'react-toastify';

class TeamMembers extends Component {
  UNSAFE_componentWillMount() {
    this.setState({
      teamMembers: [],
    });

    this.props.dispatch(setPageTitle('Team Members'));
    //this.props.dispatch(getUsers([], "first_name,last_name"));
    this.props.dispatch(getRoles());
  }

  async setTeamMemberLockoutStatus(teamMemberID, newStatus) {
    const lockoutUpdateResponse = await setPersonnelLockoutStatus(teamMemberID, newStatus);

    if (lockoutUpdateResponse.data.success) {
      this.updateTeamMemberAfterLockoutUpdate(teamMemberID, newStatus);
    }
  }

  updateTeamMemberAfterLockoutUpdate(teamMemberID, newStatus) {
    const { teamMembers } = this.state;

    const newTeamMembers = [...teamMembers];

    for (const index in newTeamMembers) {
      const currentTeamMember = newTeamMembers[index];
      if (currentTeamMember.id === teamMemberID) {
        currentTeamMember.lockout = newStatus;
        newTeamMembers[index] = currentTeamMember;
      }
    }

    this.setState({ teamMembers: newTeamMembers });
  }

  async componentDidMount() {
    const teamMembersResponse = await getTeamMembers(true);

    if (teamMembersResponse.data && teamMembersResponse.data.success) {
      const teamMembers = teamMembersResponse.data.team_members;
      this.setState({ teamMembers: teamMembers });
    }

    const queryString = parseQuery(window.location);

    if (queryString && queryString.message) {
      const message = queryString.message;

      toast.success(unescape(message), {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  displayTeamMembers(lockout) {
    const { teamMembers } = this.state;
    const { user } = this.props;

    let userID = -1;
    if (user) {
      userID = user.currentUserId;
    }

    return teamMembers.map((user) => {
      const userRole = user.roles[0];
      let isLoggedInUser = false;
      if (user.id === userID) {
        isLoggedInUser = true;
      }

      if (lockout && user.lockout) {
        return (
          <Col md="6" key={user.id}>
            <TeamMemberCard
              lockout_func={this.setTeamMemberLockoutStatus.bind(this)}
              teamMember={user}
              role={userRole}
              me={isLoggedInUser}
              isAdminRole={this.props.isAdminRole}
            />
          </Col>
        );
      } else if (!lockout && !user.lockout) {
        return (
          <Col md="6" key={user.id}>
            <TeamMemberCard
              lockout_func={this.setTeamMemberLockoutStatus.bind(this)}
              teamMember={user}
              role={userRole}
              me={isLoggedInUser}
              isAdminRole={this.props.isAdminRole}
            />
          </Col>
        );
      } else {
        return '';
      }
    });
  }

  render() {
    const { isAdminRole } = this.props;
    const { teamMembers } = this.state;
    return (
      <Container>
        {isAdminRole && (
          <div className="m-3 text-left">
            <Link to="/teamMember">
              <Button
                text="Add Team Member"
                color="primary"
                onClick={() => {
                  this.props.dispatch(resetUserState());
                }}
              />
            </Link>
          </div>
        )}
        <Row>
          {teamMembers && this.displayTeamMembers(false)}
          {teamMembers && this.displayTeamMembers(true)}
        </Row>
      </Container>
    );
  }
}

const withState = connect((state) => {
  const { role, user } = state;

  // This is absolutely not the way to do this... I could not figure out the appropriate url query
  //   It could be done in a flask endpoint, but I feel this should be possible in eve
  // https://stackoverflow.com/questions/50298923/how-do-i-query-resources-in-the-nested-collection-in-eve-sqlalchemy
  // let users = user.users;
  //let organization = user.organization;

  // if (users && !user.isSuperRole) {
  //     users = users.filter(user => {
  //         return user.organizations && user.organizations.includes(organization)
  //     })
  // }

  return {
    roles: role.roles,
    user: user,
    isSuperRole: user.isSuperRole,
    isAdminRole: user.isAdminRole,
  };
});

export default withRouter(withState(TeamMembers));
